import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getClient(id) {
  const response = await fetch(`${baseUrl}clients/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getClients() {
  const response = await fetch(`${baseUrl}clients`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveClient(client) {
  const response = await fetch(`${baseUrl}clients/${client.id || ""}`, {
    method: client.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(client),
  });
  return handleResponse(response);
}

async function requestMerge(body) {
  const response = await fetch(`${baseUrl}merge-clients`, {
    method: 'POST', headers: authHeaders({ 'content-type': 'application/json' }), body: JSON.stringify(body),
  });
  if (response.ok || response.status === 401) return handleResponse(response);
  let details;
  try { details = await response.json(); } catch (error) { details = {}; }
  throw Object.assign(new Error(details.code || 'MERGE_RESULT_UNCONFIRMED'), {
    code: details.code || 'MERGE_RESULT_UNCONFIRMED', outcome: details.outcome || 'unknown', blockers: details.blockers || [],
  });
}

async function previewClientMerge(sourceId, targetId) {
  return requestMerge({ operation: 'preview', contractVersion: 2, sourceId, targetId });
}

async function mergeClients(sourceId, targetId, mergeData) {
  const command = { ...mergeData, sourceId, targetId, operation: 'execute', contractVersion: 2 };
  let result = await requestMerge(command);
  while (result.outcome === 'inProgress') {
    // Each server response advances a durable checkpoint; reuse the exact plan.
    // eslint-disable-next-line no-await-in-loop
    result = await requestMerge(command);
  }
  return result;
}

export default {
  getClient,
  getClients,
  saveClient,
  mergeClients,
  previewClientMerge,
};
